import { cabinetsControllerApproveCabinet } from './cabinetsControllerApproveCabinet'
import { cabinetsControllerCreateCabinet } from './cabinetsControllerCreateCabinet'
import { cabinetsControllerDeleteCabinet } from './cabinetsControllerDeleteCabinet'
import { cabinetsControllerGetSchoolCabinets } from './cabinetsControllerGetSchoolCabinets'

export const cabinetsService = { cabinetsControllerCreateCabinet, cabinetsControllerGetSchoolCabinets, cabinetsControllerApproveCabinet, cabinetsControllerDeleteCabinet }